<template>
  <div class="table-container">
    <table class="styled-table">
      <tbody>
        <tr>
          <td>
            <!-- Mostrar título de la sección -->
            <span class="titulo-seccion">{{ section.titulo_seccion }}</span>
            <ul>
              <li v-for="(archivo, i) in section.archivos_seccion" :key="i">
                <div class="contenido-fila">
                  <!-- Mostrar título del archivo -->
                  <span class="contenido-titulo">{{ archivo.titulo || 'Descargar documento' }}</span>

                  <!-- Contenedor para los íconos -->
                  <div class="iconos-contenedor">
                    <a v-if="archivo.url_pdf" :href="urlServe + archivo.url_pdf" target="_blank">
                      <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                    </a>
                    <a v-if="archivo.url_word" :href="urlServe + archivo.url_word" target="_blank">
                      <i class="fas fa-file-word icono-archivo icon-word"></i>
                    </a>
                    <a v-if="archivo.url_excel" :href="urlServe + archivo.url_excel" target="_blank">
                      <i class="fas fa-file-excel icono-archivo icon-excel"></i>
                    </a>
                    <a v-if="archivo.url_comprimido" :href="urlServe + archivo.url_comprimido" target="_blank">
                      <i class="fas fa-file-archive icono-archivo icon-rar"></i>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    urlServe: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.table-container{
  border-bottom: 1px solid #cfcfcf;
}
.titulo-seccion {
  font-weight: bold;
  font-size: 1rem;
}

.contenido-fila {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem; /* Espacio entre los archivos */
}
.contenido-titulo{
  margin-right: 2rem;
}
.iconos-contenedor {
  display: flex;
  font-size: 1.2rem;
  gap: 5px;
}

.icons a:hover {
    color: #007bff; 
}
.icon-pdf{
    color: #e74c3c!important; 
}
.icon-word {
    color: #007bff!important;
}
.icon-excel {
    color: #28a745!important;
}
.icon-rar {
    color: #f39c12!important;
}
</style>
